const NAMESPACE = 'mint';

export const selectIsMintInitialized = (state) => state?.[NAMESPACE]?.isInitialized;
export const selectDeregisterDisplayAds = (state) => state?.[NAMESPACE]?.deregisterDisplayAds;
